import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api/index'
import formatMoney from './plugins/formatMoney'
import formValidate from './plugins/formValidate'
import WebUploader from './plugins/initWebUploader'
import showToast from './plugins/showToast'
import scrollPlugin from './plugins/willScrollToBottom'
import isWxBrowser from './plugins/isWxBrowser'
import { UiServicesPlugin, ui } from './ui/services'
import 'vant/lib/index.css'
import '@/ui/compat.less'
import './plugins/input.js'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(UiServicesPlugin)
app.use(api)
app.use(formatMoney)
app.use(formValidate)
app.use(WebUploader)
app.use(showToast)
app.use(scrollPlugin)
app.use(isWxBrowser)

ui.loading.hide()

const routerFiles = [{ '1': 'store' }, { '3': 'myBuy' }, { '4': 'service' }]
router.beforeEach(to => {
  if (to.query.access_token && to.query.access_token !== 'undefined') localStorage.access_token = to.query.access_token
  if (to.query.auth_id && to.query.auth_id !== 'undefined') localStorage.auth_id = to.query.auth_id
  const token = localStorage.access_token
  const notNeedAuth = to.meta && to.meta.notNeedAuth
  if (!notNeedAuth && !token) return '/'

  let navTabIndex = 0
  routerFiles.forEach(item => {
    for (const key in item) {
      if (to.path.includes(item[key] + '_')) navTabIndex = Number(key)
    }
  })
  store.dispatch('CHANGE_NAV_INDEX', to.path.toLowerCase().includes('store_shopcart') ? 2 : navTabIndex)
  return true
})

// 避免旧页面未完成的请求或跳转遗留全屏加载层，遮挡新页面操作。
router.afterEach(() => ui.loading.hide())
router.onError(error => {
  ui.loading.hide()
  console.error('Router navigation error:', error)
})

window._isPhone = /^1[345789][0-9]{9}$/
app.mount('#app')
